import BucketsGrid from '../components/Grid';
import { BucketProvider } from '../store';

export default function BucketsGridLayout() {
  return <BucketProvider>
    <BucketsGrid />
  </BucketProvider>
}

